/**
 * DEVELOPER DOCUMENTATION
 *
 * Include your custom JavaScript here.
 *
 * The theme Focal has been developed to be easily extensible through the usage of a lot of different JavaScript
 * events, as well as the usage of custom elements (https://developers.google.com/web/fundamentals/web-components/customelements)
 * to easily extend the theme and re-use the theme infrastructure for your own code.
 *
 * The technical documentation is summarized here.
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A VARIANT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a the user has changed the variant in a selector. The target get you the form
 * that triggered this event.
 *
 * Example:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   let variant = event.detail.variant; // Gives you access to the whole variant details
 *   let form = event.target;
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * MANUALLY CHANGE A VARIANT
 * ------------------------------------------------------------------------------------------------------------
 *
 * You may want to manually change the variant, and let the theme automatically adjust all the selectors. To do
 * that, you can get the DOM element of type "<product-variants>", and call the selectVariant method on it with
 * the variant ID.
 *
 * Example:
 *
 * const productVariantElement = document.querySelector('product-variants');
 * productVariantElement.selectVariant(12345);
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A NEW VARIANT IS ADDED TO THE CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a variant is added to the cart through a form selector (product page, quick
 * view...). This event DOES NOT include any change done through the cart on an existing variant. For that,
 * please refer to the "cart:updated" event.
 *
 * Example:
 *
 * document.addEventListener('variant:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN THE CART CONTENT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever the cart content has changed (if the quantity of a variant has changed, if a variant
 * has been removed, if the note has changed...). This event will also be emitted when a new variant has been
 * added (so you will receive both "variant:added" and "cart:updated"). Contrary to the variant:added event,
 * this event will give you the complete details of the cart.
 *
 * Example:
 *
 * document.addEventListener('cart:updated', function(event) {
 *   var cart = event.detail.cart; // Get the updated content of the cart
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * REFRESH THE CART/MINI-CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * If you are adding variants to the cart and would like to instruct the theme to re-render the cart, you cart
 * send the cart:refresh event, as shown below:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 *
 * ------------------------------------------------------------------------------------------------------------
 * USAGE OF CUSTOM ELEMENTS
 * ------------------------------------------------------------------------------------------------------------
 *
 * Our theme makes extensive use of HTML custom elements. Custom elements are an awesome way to extend HTML
 * by creating new elements that carry their own JavaScript for adding new behavior. The theme uses a large
 * number of custom elements, but the two most useful are drawer and popover. Each of those components add
 * a "open" attribute that you can toggle on and off. For instance, let's say you would like to open the cart
 * drawer, whose id is "mini-cart", you simply need to retrieve it and set its "open" attribute to true (or
 * false to close it):
 *
 * document.getElementById('mini-cart').open = true;
 *
 * Thanks to the power of custom elements, the theme will take care automagically of trapping focus, maintaining
 * proper accessibility attributes...
 *
 * If you would like to create your own drawer, you can re-use the <drawer-content> content. Here is a simple
 * example:
 *
 * // Make sure you add "aria-controls", "aria-expanded" and "is" HTML attributes to your button:
 * <button type="button" is="toggle-button" aria-controls="id-of-drawer" aria-expanded="false">Open drawer</button>
 *
 * <drawer-content id="id-of-drawer">
 *   Your content
 * </drawer-content>
 *
 * The nice thing with custom elements is that you do not actually need to instantiate JavaScript yourself: this
 * is done automatically as soon as the element is inserted to the DOM.
 *
 * ------------------------------------------------------------------------------------------------------------
 * THEME DEPENDENCIES
 * ------------------------------------------------------------------------------------------------------------
 *
 * While the theme tries to keep outside dependencies as small as possible, the theme still uses third-party code
 * to power some of its features. Here is the list of all dependencies:
 *
 * "vendor.js":
 *
 * The vendor.js contains required dependencies. This file is loaded in parallel of the theme file.
 *
 * - custom-elements polyfill (used for built-in elements on Safari - v1.0.0): https://github.com/ungap/custom-elements
 * - web-animations-polyfill (used for polyfilling WebAnimations on Safari 12, this polyfill will be removed in 1 year - v2.3.2): https://github.com/web-animations/web-animations-js
 * - instant-page (v5.1.0): https://github.com/instantpage/instant.page
 * - tocca (v2.0.9); https://github.com/GianlucaGuarini/Tocca.js/
 * - seamless-scroll-polyfill (v2.0.0): https://github.com/magic-akari/seamless-scroll-polyfill
 *
 * "flickity.js": v2.2.0 (with the "fade" package). Flickity is only loaded on demand if there is a product image
 * carousel on the page. Otherwise it is not loaded.
 *
 * "photoswipe": v4.1.3. PhotoSwipe is only loaded on demand to power the zoom feature on product page. If the zoom
 * feature is disabled, then this script is never loaded.
 */


if (window.location.pathname.indexOf("/products") !== -1) {
  console.log("out of stock here");
  var klaviyo = klaviyo || [];
  klaviyo.init({
    account: "Kfmw6g",
    platform: "shopify",
  });
  klaviyo.enable("backinstock", {
    trigger: {
      product_page_text: "Notify Me When Available",
      product_page_class: "product-form__add-button",
      product_page_text_align: "center",
      product_page_margin: "0px",
      replace_sold_out: false,
    },
    modal: {
      headline: "{product_name}",
      body_content:
        "Register to receive a notification when this item comes back in stock.",
      email_field_label: "Email",
      button_label: "Notify me when available",
      subscription_success_label:
        "You're in! We'll let you know when it's back.",
      footer_content: "",
      close_label: "Close",
      additional_styles:
        "@import url('https://fonts.googleapis.com/css?family=Helvetica+Neue');",
      font_family: "'EffraMain', sans-serif",
      drop_background_color: "#000",
      background_color: "#000",
      text_color: "#fff",
      button_text_color: "#fff",
      button_background_color: "#e24337",
      close_button_color: "#ccc",
      error_background_color: "#fcd6d7",
      error_text_color: "#C72E2F",
      success_background_color: "#d3efcd",
      success_text_color: "#1B9500",
    },
  });
}

function change_chinos_color(event) {
  console.log("here");
  console.log(event.target);
var url = event.target.getAttribute("data-url");  
const myHeaders = new Headers();
const requestOptions = {
  method: "GET",
  headers: myHeaders,
};
var template = event.target.getAttribute("data-template");
var new_template = event.target.getAttribute("data-template");
if (!window.location.href.includes("/products")) {
  //  new_template = 'template--15790334967917__main'; // dev template
   new_template = 'template--'+window.template_section_id+'__main';
}
fetch(url+"?section_id="+new_template, requestOptions)
  .then((response) => response.text())
  .then((result) => {      
        
    var section_id = 'shopify-section-'+template;
    var full_form = '';
    var currentFullForm = '';
    const parser = new DOMParser();
    const doc = parser.parseFromString(result, 'text/html');
    
    if (!window.location.href.includes("/products")) {
       console.log("ww");
       full_form = doc.querySelector('.product');
    }else {
      console.log("hehehehhe");
      full_form = doc.querySelector('#'+section_id);
    }
    
    
    if (full_form) {
      if (!window.location.href.includes("/products")) {
        currentFullForm = document.querySelector('.product');
      }else {
        currentFullForm = document.querySelector('#'+section_id);
      }
      
      if (currentFullForm) {
        
        currentFullForm.innerHTML = full_form.innerHTML;
        
        var waist_value_new = localStorage.getItem("waist_value");
        var inseam_value_new = localStorage.getItem("inseam_value");
        const selected_input_waist = document.querySelector('input.product-Waist[value="'+waist_value_new+'"]');
        const selected_input_inseam = document.querySelector('input.product-Inseam[value="'+inseam_value_new+'"]');
       
        if (selected_input_waist) {
            setTimeout(function() {
                selected_input_waist.click();
            }, 1000); 
        }
        
        if (selected_input_inseam) {
            setTimeout(function() {
                selected_input_inseam.click();
            }, 1000); 
        }
        
        console.log('Frontend content replaced successfully');
      } else {
        console.error('<product-variants> tag not found on the current page');
      }
    } else {
      console.error('<product-variants> tag not found in fetched content');
    }
  })
  .catch((error) => console.error('Error:', error));
  
}

// If we are on a product page
if (window.location.pathname.indexOf("/products/") !== -1 || document.querySelector('.shopify-section--featured-product') !== null) {
  okeReviewsWidgetOnInit = function () {
    var stars = document.querySelectorAll(".js-okeReviews-reviewsSummary");
    stars.forEach(function (element) {
      element.querySelector(
        ".okeReviews-reviewsSummary-ratingCount"
      ).innerText =
        element.querySelector(".okeReviews-a11yText").innerText.split(" ")[1] +
        " Stars";
      element.querySelector(
        ".okeReviews-reviewsSummary-ratingCount"
      ).style.display = "inline-block";
    });
  };

  document.addEventListener("DOMContentLoaded", function (event) {
  
 document.body.addEventListener("click", function(event) {
   
        // Check if the clicked element has the class 'fake-color-picker-item'
        if (event.target.classList.contains("fake-color-picker-item")) {
            change_chinos_color(event);
        }
    });

    if (pk_product_type == "__type:chinos") {
      document.body.addEventListener('change', (event) => {
        if (event.target.matches('.block-swatch__radio')) {
          product_option_change(event);
        }
      });

      var stored_waist_value = localStorage.getItem("waist_value");

      if (localStorage.hasOwnProperty("waist_value")) {
        setTimeout(function () {
          var swatch_option = document.querySelectorAll(".product-Waist");

          for (var i = 0; i < swatch_option.length; i++) {
            if (swatch_option[i].value == stored_waist_value) {
              swatch_option[i].click();
            }
          }
        }, 2000);
      }
      var inseam_waist_value = localStorage.getItem("inseam_value");

      if (localStorage.hasOwnProperty("inseam_value")) {
        setTimeout(function () {
          var swatch_option2 = document.querySelectorAll(".product-Inseam");

          for (var i = 0; i < swatch_option2.length; i++) {
            if (swatch_option2[i].value == inseam_waist_value) {
              swatch_option2[i].click();
            }
          }
        }, 2000);
      }
    }
  });
}

function product_option_change() {
  var product_options = document.getElementsByClassName(
    "product-form__option-name"
  );

  var heightRanges = {
      "30": "(Heights 5'8 to 5'10)",
      "32": "(Heights 5'10 to 6'1)",
      "34": "(Heights 6'1 to 6'4)",
    };
  var out = [];
  setTimeout(
    function () {
      for (var i = 0; i < product_options.length; i++) {
        var option_text = product_options[i].innerHTML;
        var waist = option_text.includes("Waist");
        var inseam = option_text.includes("Inseam");
        if (waist) {
          var waist_selected_ele = document.querySelector(
            ".product-swatch-waist .block-swatch__radio:checked+.block-swatch__item"
          );

          if (waist_selected_ele) {
            console.log(waist_selected_ele.innerHTML);
            var waist_value = waist_selected_ele.innerHTML;
            localStorage.setItem("waist_value", waist_value);
          }
        } else if (inseam) {
        
          var inseam_selected_ele = document.querySelector(
            ".product-swatch-inseam .block-swatch__radio:checked+.block-swatch__item"
          );
           var heightTextElement = document.getElementById("height-text-inseam");
         

          if (inseam_selected_ele) {
             console.log("ere");
          console.log(heightRanges);
          console.log(heightRanges[32]);
            console.log(inseam_selected_ele.innerHTML)
            console.log(heightTextElement);
             if (heightTextElement) {
              heightTextElement.innerText = heightRanges[inseam_selected_ele.innerHTML] || "";
            }
            var inseam_value = inseam_selected_ele.innerHTML;
            localStorage.setItem("inseam_value", inseam_value);
          }
        }
      }
    },

    1000
  );
}

var myFunction = function (event) {

  var attribute = event.getAttribute("data-variant-id");
 
  if(!attribute) {
      attribute = document.getElementById('sizeSelect').value;
  }

  if(!attribute) {
    alert("Please select size/color");
  }
  var formBody =
    '{"form_type":"product","utf8":"✓","id":"' +
    attribute +
    '","quantity":"1"}';

  fetch(`${window.themeVariables.routes.cartAddUrl}.js`, {
    body: formBody,
    credentials: "same-origin",
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "X-Requested-With": "XMLHttpRequest", // This is needed as currently there is a bug in Shopify that assumes this header
    },
  }).then(function (response) {
    fetch(`${window.themeVariables.routes.cartUrl}.js`).then(
      async (response2) => {
        const cartContent = await response2.json();

        document.documentElement.dispatchEvent(
          new CustomEvent("cart:refresh", {
            bubbles: true,
            detail: {
              cart: cartContent,
            },
          })
        );
      }
    );
  });
};

if (window.location.pathname.indexOf("/products/") !== -1) {
  okeReviewsWidgetOnInit = function () {
   var final_rating = 4.9;
   var rate_element = document.querySelector('.okeReviews-reviewsSummary-starRating .okeReviews-a11yText');
    if (rate_element) {
        var text_content = rate_element.textContent; 
        const match_content = text_content.match(/Rated (\d+(\.\d+)?) out of 5/); 

        if (match_content) {
          final_rating = match_content[1];
            
        }
    }
    var final_review_count = "500";
    var review_count_element = document.querySelector('.okeReviews-reviewsSummary-ratingCount .okeReviews-a11yText');
    if (review_count_element) {
        const review_count_text = review_count_element.textContent; 
        const review_count_match = review_count_text.match(/Based on (\d+) reviews/); 

        if (review_count_match) {
            final_review_count =  parseInt(review_count_match[1], 10); 
        }
    }
    console.log(final_review_count);
    console.log(final_rating);
    
 
    var new_total_reviews = document.querySelectorAll(
      ".pdp-reviews-summary .okeReviews-reviewsSummary-ratingCount"
    );

    var new_total_reviews_b = document.querySelectorAll(
      ".pdp-reviews-summary-new-clean-pdp-test-b .okeReviews-reviewsSummary-ratingCount"
    );
    

    if(new_total_reviews) {
      
      new_total_reviews[0].innerHTML = final_rating + " based on <span class='reviews_underline'>"+final_review_count+" reviews</span>";
      new_total_reviews[0].style.display = "inline-block";
    }

    if(new_total_reviews_b) {
     new_total_reviews_b[0].innerHTML = final_rating + " (+ <span class='reviews_underline'>"+final_review_count+" reviews)</span>";
      new_total_reviews_b[0].style.display = "inline-block";
     
    }
  
    
  };
}
if (window.location.href.includes("open-minicart"))
  document.getElementById("mini-cart").open = true;

var acc = document.getElementsByClassName("footer-accordian-title");
var i;

for (i = 0; i < acc.length; i++) {
  acc[i].addEventListener("click", function () {
    this.classList.toggle("active");
    var panel = this.nextElementSibling;
    if (panel.style.display === "block") {
      panel.style.display = "none";
    } else {
      panel.style.display = "block";
    }
  });
}
function getUrlVars() {
  var vars = {};
  var parts = window.location.href.replace(
    /[?&]+([^=&]+)=([^&]*)/gi,
    function (m, key, value) {
      vars[key] = value;
    }
  );
  return vars;
}
function get_cookie_val(name) {
  var value = "; " + document.cookie,
    parts = value.split("; " + name + "=");

  if (parts.length === 2) {
    return parts.pop().split(";").shift();
  }

  return "";
}

function createCookie(name, value, days) {
  if (days) {
    var date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    var expires = "; expires=" + date.toGMTString();
  } else var expires = "";
  document.cookie = name + "=" + value + expires + "; path=/";
}

var perk_lp_offer = get_cookie_val("perk_lp_offer");
var perk_lp_offer_url = "";

var window_href = window.location.href;
if (
  window_href.indexOf("mens-slim-fit-chinos") > -1 ||
  window_href.indexOf("chino-pants-for-men") > -1
) {
  perk_lp_offer_url = "COUPON_CHINO30OFF";
} else if (window_href.indexOf("buy-3-chino-pants-for-men") > -1) {
  perk_lp_offer_url = "COUPON_CHINO100OFF";
} else if (window_href.indexOf("buy-2-mens-chinos") > -1 || window_href.indexOf("prime-specials") > -1) {
  perk_lp_offer_url = "COUPON_CHINO20OFF";
}

var cookie_coupon_code = get_cookie_val("discount_code");

if (perk_lp_offer_url && perk_lp_offer !== perk_lp_offer_url) {
  createCookie("perk_lp_offer", perk_lp_offer_url, -300);
  perk_lp_offer = perk_lp_offer_url;
}
createCookie("perk_lp_offer", "", -300);

if(cookie_coupon_code.includes("20LABOR")) {
  perk_lp_offer = "COUPON_"+cookie_coupon_code;
}

if (perk_lp_offer && perk_lp_offer.includes("COUPON_")) {
  var final_coupon = perk_lp_offer.replace("COUPON_", "");
  setTimeout(apply_coupon(final_coupon), 1000);
}
function apply_general_coupon(cart_data = "") {
  if (cart_data) {
  // apply_coupon_final_ps("ANNIVERSARY20", cart_data);
  // apply_general_coupon_final(cart_data); #original
    apply_general_coupon_fg_polo(cart_data);
    
  }
  else {
    fetch("/cart.js")
      .then(function (response) {
        if (response.status !== 200) {
          console.log(
            "Looks like there was a problem. Status Code: " + response.status
          );
          return;
        }

        // Examine the text in the response
        response.json().then(function (data) {
        // apply_coupon_final_ps("ANNIVERSARY20", data);
    
        apply_general_coupon_fg_polo(data);
       //  apply_general_coupon_final(data); #original
          
        });
      })
      .catch(function (err) {
        console.log("Fetch Error :-S", err);
      });
  }
}
function apply_general_coupon_fg_polo(cart) {
    var mini_cart_savings = document.getElementById("mini-cart-savings");
    var mini_cart_form = document.getElementById("mini-cart-form");
    var mini_cart_button_subtotal = document.getElementById(
      "mini-cart-button-subtotal"
    );
    var mini_cart_upsell_items = document.getElementById(
      "mini-cart-upsell-items"
    );
    var calculated_discount_val = 0;
    var final_calculated_discount_val = 0;
    var discountTitles = [];
    var discount_array = ["", ""];
    var count_fg = 0;
    var compare_at_savings = 0;
  
    var multiplier = {
      "T-Shirts": {
        m: 3,
        index: 0,
        code: "T",
        cart_qty: 0,
        discount: 1500,
      },
      Chinos: {
        m: 3,
        index: 1,
        code: "C",
        cart_qty: 0,
        discount: 8700,
      },
      Shorts: {
        m: 2,
        index: 2,
        code: "S",
        cart_qty: 0,
        discount: 4000,
        selected_size: "",
      },
      Polos: {
        m: 3,
        index: 3,
        code: "P",
        cart_qty: 0,
        discount: 6800,
        selected_size: "",
      },
    };
    var cart_items = cart.items;
  
    var free_meter_box = document.getElementById("freeTeeMeterBox");
    var newmeterBar = document.getElementById("progress-fill");
    var new_progress_bar = document.getElementById("new2-progress-container");
  
    var newHeading = document.getElementById("new-heading");
    const remainingAmountSpan = document.getElementById("remainingAmount");
    const remainingAmountSpan2 = document.getElementById("remainingAmount2");
    var price_block_element = document.getElementById("price-test-block2");
  
    var cartTotal = cart.total_price / 100; // Example cart total
  
    if (free_meter_box) {
      console.log("variant test");
  
      if(window.igData && window.igData?.user.getTestGroup)
        var test_group = window.igData?.user.getTestGroup("1a10128c-c58e-4e5c-bd16-62831b32fa96");
      else
        var test_group = "";
      console.log(test_group);
  
      if(test_group && test_group.name == "New Group 1") {
      var test_variant_name = "new";
        if( price_block_element) 
          price_block_element.innerHTML = "SAVE $96";
      }
      else {
      var test_variant_name = "control";
        if( price_block_element) 
          price_block_element.innerHTML = "25% OFF";
      }
  
      var thresholdForFreeTee = 140;
  
      // Calculate the remaining amount needed for a free tee
      const remainingAmount = thresholdForFreeTee - cartTotal;
  
      // Calculate the progress percentage
      const progressPercentage = Math.min(
        (cartTotal / thresholdForFreeTee) * 100,
        100
      );
  
      // Update the meter bar width and remaining amount
      const meterBar = document.getElementById("freeTeeMeterBar");
  
      meterBar.style.width = `${progressPercentage}%`;
      if (remainingAmount > 0)
        remainingAmountSpan.innerHTML =
          "Spend $" + remainingAmount.toFixed(2) + " more and get free shipping!";
      else remainingAmountSpan.innerHTML = "You are eligible for free shipping!";
    }
  
    for (var i = 0; i < cart_items.length; i++) {
      var cart_item = cart_items[i];
  
      if (cart_item.discounts && cart_item.discounts.length > 0) {
        // Loop through each discount of the current item
        for (var jj = 0; jj < cart_item.discounts.length; jj++) {
          // Extract the discount title and add it to the discountTitles array
          var discountTitle = cart_item.discounts[jj].title;
          discountTitles.push(discountTitle);
        }
      }
  
      if (multiplier[cart_item.product_type])
        multiplier[cart_item.product_type].cart_qty += cart_item.quantity;
  
      if (cart_item.product_type == "Shorts") {
        // Check if cart_item.options_with_values[1] exists
        if (cart_item.options_with_values && cart_item.options_with_values[1]) {
          console.log(cart_item.options_with_values[1]);
          multiplier[cart_item.product_type].selected_size =
            cart_item.options_with_values[1].value;
        } else {
          console.log("The option at index 1 does not exist.");
        }
      }
      if (cart_item.product_type == "Polos") {
        // Check if cart_item.options_with_values[1] exists
        if (cart_item.options_with_values && cart_item.options_with_values[1]) {
          console.log(cart_item.options_with_values[1].value);
          multiplier[cart_item.product_type].selected_size =
            cart_item.options_with_values[1].value;
        } else {
          console.log("The option at index 1 does not exist.");
        }
      }
  
      if (cart_item.title.includes("Perk Feel Good Polo")) {
        compare_at_savings += 8900;
        count_fg += 1;
      }
      if (cart_item.title.includes("Perk Feel Good Tee")) {
        compare_at_savings += 3800;
        count_fg += 1;
      }
      if (cart_item.title.includes("Perk Feel Good Shorts")) {
        compare_at_savings += 9900;
        count_fg += 1;
      }
    }
  
    var allNewSteps = document.querySelectorAll(".new-step");
  
    document.querySelectorAll(".new-step").forEach((element) => {
      element.classList.remove("new-step-selected");
    });
  
    if (multiplier["Chinos"]["cart_qty"] == 0 && cartTotal > 0) {
      free_meter_box.style.display = "block";
      new_progress_bar.style.display = "none";
    } else if (multiplier["Chinos"]["cart_qty"] == 1 && cartTotal < 140) {
      free_meter_box.style.display = "none";
      new_progress_bar.style.display = "flex";
  
      newmeterBar.style.width = `40%`;
      var newremainingAmount = thresholdForFreeTee - cartTotal;
      remainingAmountSpan2.innerHTML = "Unlock our deals!";
      newHeading.innerHTML =
        "You’re $" +
        newremainingAmount.toFixed(2) +
        " away to get FREE Shipping";
    } else if (multiplier["Chinos"]["cart_qty"] == 1 && cartTotal >= 140) {
      free_meter_box.style.display = "none";
      new_progress_bar.style.display = "flex";
      newmeterBar.style.width = `40%`;
  
      remainingAmountSpan2.innerHTML = "YOU’VE UNLOCKED FREE SHIPPING!";
      newHeading.innerHTML = "Add 1 more chinos to get 20% OFF!";
      allNewSteps[0].classList.add("new-step-selected");
    } else if (multiplier["Chinos"]["cart_qty"] == 2 && count_fg == 0) {
      free_meter_box.style.display = "none";
      new_progress_bar.style.display = "flex";
      newmeterBar.style.width = `65%`;
  
      remainingAmountSpan2.innerHTML = "YOU’VE UNLOCKED 20% OFF offer!";
      newHeading.innerHTML = "Add 1 more chinos to get 25% OFF!";
      allNewSteps[0].classList.add("new-step-selected");
    } else if (multiplier["Chinos"]["cart_qty"] == 2 && count_fg >= 1) {
      free_meter_box.style.display = "none";
      new_progress_bar.style.display = "flex";
      remainingAmountSpan2.innerHTML = "YOU’VE UNLOCKED 20% OFF offer!";
      newHeading.innerHTML = test_variant_name == "control" ? "You’re $32 away to get $87 OFF" : "You’re $32 away to get $96 OFF";
  
      newmeterBar.style.width = `65%`;
      allNewSteps[0].classList.add("new-step-selected");
      allNewSteps[1].classList.add("new-step-selected");
    } else if (multiplier["Chinos"]["cart_qty"] > 2) {
      free_meter_box.style.display = "none";
      new_progress_bar.style.display = "flex";
      newmeterBar.style.width = `100%`;
      remainingAmountSpan2.innerHTML = "You’ve unlocked all our deals! 🎁";
      newHeading.innerHTML = "Congratulations";
  
      allNewSteps[0].classList.add("new-step-selected");
      allNewSteps[1].classList.add("new-step-selected");
    }
  
    if (multiplier["Chinos"]["cart_qty"] == 1) {
      update_mini_cart_upsell_title(
        "Add 2 more pair of chinos to get $87 OFF"
      );
    } else if (multiplier["Chinos"]["cart_qty"] == 2) {
      update_mini_cart_upsell_title("Add 1 more pair of chinos for only $32");
    } else if (multiplier["Shorts"]["cart_qty"] == 1) {
      update_mini_cart_upsell_title("Add 1 more Shorts to get $40 off");
      if (mini_cart_upsell_items) {
        var upsell_html = render_upsell_html(
          multiplier["Shorts"]["selected_size"]
        );
      }
    } else if (multiplier["Polos"]["cart_qty"] == 1) {
      update_mini_cart_upsell_title("Add 2 more Polo Tee to get $68 off");
      if (mini_cart_upsell_items) {
        var upsell_html = render_upsell_html_polos(
          multiplier["Polos"]["selected_size"]
        );
      }
    } else if (multiplier["Polos"]["cart_qty"] == 2) {
      update_mini_cart_upsell_title("Add 1 more Polo Tee to get $68 off");
      if (mini_cart_upsell_items) {
        var upsell_html = render_upsell_html_polos(
          multiplier["Polos"]["selected_size"]
        );
      }
    } else {
      update_mini_cart_upsell_title("YOU MAY ALSO LIKE");
    }
  
    for (var key in multiplier) {
      var bundle_eligible = Math.floor(
        multiplier[key].cart_qty / multiplier[key].m
      );
      if (bundle_eligible > 0) {
        calculated_discount_val += multiplier[key].discount * bundle_eligible;
        discount_array[multiplier[key].index] =
          bundle_eligible * multiplier[key].m + multiplier[key].code;
      }
    }
  
    if (count_fg == 0 && multiplier["Chinos"]["cart_qty"] >= 2) {
    //  renderProductSection("perk-feel-good-tee");
    }
  
    var filtered = discount_array.filter(function (el) {
      return el != "";
    });
    var coupon_code = filtered.join("-");
    coupon_code = "";
    console.log("all discounts");
    console.log(discountTitles);
  
    if (coupon_code) {
      var new_final_savings = calculated_discount_val + compare_at_savings;
  
      coupon_code = "BDL-" + coupon_code;
  
      if (discountTitles.includes(coupon_code)) {
        final_calculated_discount_val = 0;
      } else final_calculated_discount_val = calculated_discount_val;
      console.log(discountTitles.includes(coupon_code));
      console.log(coupon_code);
      console.log(calculated_discount_val);
      if (mini_cart_savings)
        mini_cart_savings.innerHTML =
          "Savings unlocked " +
          window.formatMoney(new_final_savings) +
          "! <br />Apply coupon <strong>" +
          coupon_code +
          "</strong> at checkout!";
  
      // mini_cart_savings.innerHTML =
      //   "Total Savings:&nbsp; " + window.formatMoney(calculated_discount_val);
      if (mini_cart_form) mini_cart_form.action = "/cart?discount=" + coupon_code;
    } else {
      if (cart.total_discount > 0)
        mini_cart_savings.innerHTML =
          "Total Savings:&nbsp; " + window.formatMoney(cart.total_discount);
      if (mini_cart_form) mini_cart_form.action = "/cart";
    }
  
    if (mini_cart_button_subtotal) {
      mini_cart_button_subtotal.innerHTML =
        ' <span class="square-separator"></span>' +
        window.formatMoney(cart.total_price - final_calculated_discount_val);
    }
  }

function apply_general_coupon_fg_polo_bck(cart) {
  var mini_cart_savings = document.getElementById("mini-cart-savings");
  var mini_cart_form = document.getElementById("mini-cart-form");
  var mini_cart_button_subtotal = document.getElementById(
    "mini-cart-button-subtotal"
  );
  var mini_cart_upsell_items = document.getElementById(
    "mini-cart-upsell-items"
  );
  var calculated_discount_val = 0;
  var final_calculated_discount_val = 0;
  var discountTitles = [];
  var discount_array = ["", ""];
  var count_fg = 0;
  var compare_at_savings = 0;

  var multiplier = {
    "T-Shirts": {
      m: 3,
      index: 0,
      code: "T",
      cart_qty: 0,
      discount: 1500,
    },
    Chinos: {
      m: 3,
      index: 1,
      code: "C",
      cart_qty: 0,
      discount: 8700,
    },
    Shorts: {
      m: 2,
      index: 2,
      code: "S",
      cart_qty: 0,
      discount: 4000,
      selected_size: "",
    },
    Polos: {
      m: 3,
      index: 3,
      code: "P",
      cart_qty: 0,
      discount: 6800,
      selected_size: "",
    },
  };
  var cart_items = cart.items;

  var free_meter_box = document.getElementById("freeTeeMeterBox");
  var newmeterBar = document.getElementById("new-progress");
  var new_progress_bar = document.getElementById("new-progress-bar");

  var newHeading = document.getElementById("new-heading");
  const remainingAmountSpan = document.getElementById("remainingAmount");
  const remainingAmountSpan2 = document.getElementById("remainingAmount2");
  var price_block_element = document.getElementById("price-test-block2");

  var cartTotal = cart.total_price / 100; // Example cart total

  if (free_meter_box) {
    console.log("variant test");

    if(window.igData && window.igData?.user.getTestGroup)
      var test_group = window.igData?.user.getTestGroup("1a10128c-c58e-4e5c-bd16-62831b32fa96");
    else
      var test_group = "";
    console.log(test_group);

    if(test_group && test_group.name == "New Group 1") {
    var test_variant_name = "new";
      if( price_block_element) 
        price_block_element.innerHTML = "SAVE $96";
    }
    else {
    var test_variant_name = "control";
      if( price_block_element) 
        price_block_element.innerHTML = "25% OFF";
    }

    var thresholdForFreeTee = 140;

    // Calculate the remaining amount needed for a free tee
    const remainingAmount = thresholdForFreeTee - cartTotal;

    // Calculate the progress percentage
    const progressPercentage = Math.min(
      (cartTotal / thresholdForFreeTee) * 100,
      100
    );

    // Update the meter bar width and remaining amount
    const meterBar = document.getElementById("freeTeeMeterBar");

    meterBar.style.width = `${progressPercentage}%`;
    if (remainingAmount > 0)
      remainingAmountSpan.innerHTML =
        "Spend $" + remainingAmount.toFixed(2) + " more and get free shipping!";
    else remainingAmountSpan.innerHTML = "You are eligible for free shipping!";
  }

  for (var i = 0; i < cart_items.length; i++) {
    var cart_item = cart_items[i];

    if (cart_item.discounts && cart_item.discounts.length > 0) {
      // Loop through each discount of the current item
      for (var jj = 0; jj < cart_item.discounts.length; jj++) {
        // Extract the discount title and add it to the discountTitles array
        var discountTitle = cart_item.discounts[jj].title;
        discountTitles.push(discountTitle);
      }
    }

    if (multiplier[cart_item.product_type])
      multiplier[cart_item.product_type].cart_qty += cart_item.quantity;

    if (cart_item.product_type == "Shorts") {
      // Check if cart_item.options_with_values[1] exists
      if (cart_item.options_with_values && cart_item.options_with_values[1]) {
        console.log(cart_item.options_with_values[1]);
        multiplier[cart_item.product_type].selected_size =
          cart_item.options_with_values[1].value;
      } else {
        console.log("The option at index 1 does not exist.");
      }
    }
    if (cart_item.product_type == "Polos") {
      // Check if cart_item.options_with_values[1] exists
      if (cart_item.options_with_values && cart_item.options_with_values[1]) {
        console.log(cart_item.options_with_values[1].value);
        multiplier[cart_item.product_type].selected_size =
          cart_item.options_with_values[1].value;
      } else {
        console.log("The option at index 1 does not exist.");
      }
    }

    if (cart_item.title.includes("Perk Feel Good Polo")) {
      compare_at_savings += 8900;
      count_fg += 1;
    }
    if (cart_item.title.includes("Perk Feel Good Tee")) {
      compare_at_savings += 3800;
      count_fg += 1;
    }
    if (cart_item.title.includes("Perk Feel Good Shorts")) {
      compare_at_savings += 9900;
      count_fg += 1;
    }
  }

  var allNewSteps = document.querySelectorAll(".new-step");

  document.querySelectorAll(".new-step").forEach((element) => {
    element.classList.remove("new-step-selected");
  });

  if (multiplier["Chinos"]["cart_qty"] == 0 && cartTotal > 0) {
    free_meter_box.style.display = "block";
    new_progress_bar.style.display = "none";
  } else if (multiplier["Chinos"]["cart_qty"] == 1 && cartTotal < 140) {
    free_meter_box.style.display = "none";
    new_progress_bar.style.display = "block";

    newmeterBar.style.width = `14%`;
    var newremainingAmount = thresholdForFreeTee - cartTotal;
    remainingAmountSpan2.innerHTML = "Unlock our deals!";
    newHeading.innerHTML =
      "You’re $" +
      newremainingAmount.toFixed(2) +
      " away to get FREE Shipping";
  } else if (multiplier["Chinos"]["cart_qty"] == 1 && cartTotal >= 140) {
    free_meter_box.style.display = "none";
    new_progress_bar.style.display = "block";
    newmeterBar.style.width = `50%`;

    remainingAmountSpan2.innerHTML = "YOU’VE UNLOCKED FREE SHIPPING!";
    newHeading.innerHTML = "Add 1 more chinos to get 20% OFF!";
    allNewSteps[0].classList.add("new-step-selected");
  } else if (multiplier["Chinos"]["cart_qty"] == 2 && count_fg == 0) {
    free_meter_box.style.display = "none";
    new_progress_bar.style.display = "block";
    newmeterBar.style.width = `50%`;

    remainingAmountSpan2.innerHTML = "YOU’VE UNLOCKED 20% OFF offer!";
    newHeading.innerHTML = "Add 1 more chinos to get 25% OFF!";
    allNewSteps[0].classList.add("new-step-selected");
  } else if (multiplier["Chinos"]["cart_qty"] == 2 && count_fg >= 1) {
    free_meter_box.style.display = "none";
    new_progress_bar.style.display = "block";
    remainingAmountSpan2.innerHTML = "YOU’VE UNLOCKED 20% OFF offer!";
    newHeading.innerHTML = test_variant_name == "control" ? "You’re $32 away to get $87 OFF" : "You’re $32 away to get $96 OFF";

    newmeterBar.style.width = `75%`;
    allNewSteps[0].classList.add("new-step-selected");
    allNewSteps[1].classList.add("new-step-selected");
  } else if (multiplier["Chinos"]["cart_qty"] > 2) {
    free_meter_box.style.display = "none";
    new_progress_bar.style.display = "block";
    newmeterBar.style.width = `100%`;
    remainingAmountSpan2.innerHTML = "You’ve unlocked all our deals! 🎁";
    newHeading.innerHTML = "Congratulations";

    allNewSteps[0].classList.add("new-step-selected");
    allNewSteps[1].classList.add("new-step-selected");
  }

  if (multiplier["Chinos"]["cart_qty"] == 1) {
    update_mini_cart_upsell_title(
      "Add 2 more pair of chinos to get $87 OFF"
    );
  } else if (multiplier["Chinos"]["cart_qty"] == 2) {
    update_mini_cart_upsell_title("Add 1 more pair of chinos for only $32");
  } else if (multiplier["Shorts"]["cart_qty"] == 1) {
    update_mini_cart_upsell_title("Add 1 more Shorts to get $40 off");
    if (mini_cart_upsell_items) {
      var upsell_html = render_upsell_html(
        multiplier["Shorts"]["selected_size"]
      );
    }
  } else if (multiplier["Polos"]["cart_qty"] == 1) {
    update_mini_cart_upsell_title("Add 2 more Polo Tee to get $68 off");
    if (mini_cart_upsell_items) {
      var upsell_html = render_upsell_html_polos(
        multiplier["Polos"]["selected_size"]
      );
    }
  } else if (multiplier["Polos"]["cart_qty"] == 2) {
    update_mini_cart_upsell_title("Add 1 more Polo Tee to get $68 off");
    if (mini_cart_upsell_items) {
      var upsell_html = render_upsell_html_polos(
        multiplier["Polos"]["selected_size"]
      );
    }
  } else {
    update_mini_cart_upsell_title("YOU MAY ALSO LIKE");
  }

  for (var key in multiplier) {
    var bundle_eligible = Math.floor(
      multiplier[key].cart_qty / multiplier[key].m
    );
    if (bundle_eligible > 0) {
      calculated_discount_val += multiplier[key].discount * bundle_eligible;
      discount_array[multiplier[key].index] =
        bundle_eligible * multiplier[key].m + multiplier[key].code;
    }
  }

  if (count_fg == 0 && multiplier["Chinos"]["cart_qty"] >= 2) {
  //  renderProductSection("perk-feel-good-tee");
  }

  var filtered = discount_array.filter(function (el) {
    return el != "";
  });
  var coupon_code = filtered.join("-");
  coupon_code = "";
  console.log("all discounts");
  console.log(discountTitles);

  if (coupon_code) {
    var new_final_savings = calculated_discount_val + compare_at_savings;

    coupon_code = "BDL-" + coupon_code;

    if (discountTitles.includes(coupon_code)) {
      final_calculated_discount_val = 0;
    } else final_calculated_discount_val = calculated_discount_val;
    console.log(discountTitles.includes(coupon_code));
    console.log(coupon_code);
    console.log(calculated_discount_val);
    if (mini_cart_savings)
      mini_cart_savings.innerHTML =
        "Savings unlocked " +
        window.formatMoney(new_final_savings) +
        "! <br />Apply coupon <strong>" +
        coupon_code +
        "</strong> at checkout!";

    // mini_cart_savings.innerHTML =
    //   "Total Savings:&nbsp; " + window.formatMoney(calculated_discount_val);
    if (mini_cart_form) mini_cart_form.action = "/cart?discount=" + coupon_code;
  } else {
    if (cart.total_discount > 0)
      mini_cart_savings.innerHTML =
        "Total Savings:&nbsp; " + window.formatMoney(cart.total_discount);
    if (mini_cart_form) mini_cart_form.action = "/cart";
  }

  if (mini_cart_button_subtotal) {
    mini_cart_button_subtotal.innerHTML =
      ' <span class="square-separator"></span>' +
      window.formatMoney(cart.total_price - final_calculated_discount_val);
  }
}
function apply_general_coupon_final(cart) {
  var mini_cart_savings = document.getElementById("mini-cart-savings");
  var mini_cart_form = document.getElementById("mini-cart-form");
  var mini_cart_button_subtotal = document.getElementById(
    "mini-cart-button-subtotal"
  );
  var mini_cart_upsell_items = document.getElementById("mini-cart-upsell-items");
  var calculated_discount_val = 0;
  var discount_array = ["", ""];
  var multiplier = {
    "T-Shirts": {
      m: 3,
      index: 0,
      code: "T",
      cart_qty: 0,
      discount: 1500,
    },
    Chinos: {
      m: 3,
      index: 1,
      code: "C",
      cart_qty: 0,
      discount: 8700,
      
    },
    Shorts: {
      m: 2,
      index: 2,
      code: "S",
      cart_qty: 0,
      discount: 4900,
      selected_size: ''
    },
     Polos: {
      m: 3,
      index: 3,
      code: "P",
      cart_qty: 0,
      discount: 6800,
      selected_size: ''
    },
  };
  var cart_items = cart.items;

  for (var i = 0; i < cart_items.length; i++) {
    var cart_item = cart_items[i];

    if (multiplier[cart_item.product_type])
      multiplier[cart_item.product_type].cart_qty += cart_item.quantity;

    if(cart_item.product_type == "Shorts") {
      console.log(cart_item.options_with_values[1].value);
      multiplier[cart_item.product_type].selected_size = cart_item.options_with_values[1].value;
      
    }
     if(cart_item.product_type == "Polos") {
      console.log(cart_item.options_with_values[1].value);
      multiplier[cart_item.product_type].selected_size = cart_item.options_with_values[1].value;
    }
  }

  if (multiplier["Chinos"]["cart_qty"] == 1) {
    update_mini_cart_upsell_title("Add 2 more Chinos to get $87 off");
  } else if (multiplier["Chinos"]["cart_qty"] == 2) {
    update_mini_cart_upsell_title("Add 1 more Chinos to get $87 off");
  } 
   else if (multiplier["Shorts"]["cart_qty"] == 1) {
    update_mini_cart_upsell_title("Add 1 more Shorts to get $49 off");
     if(mini_cart_upsell_items) {
       var upsell_html  = render_upsell_html(multiplier["Shorts"]["selected_size"]);
       
     }
  } 
  else if (multiplier["Polos"]["cart_qty"] == 1) {
    update_mini_cart_upsell_title("Add 2 more Polo Tee to get $68 off");
     if(mini_cart_upsell_items) {
      var upsell_html  = render_upsell_html_polos(multiplier["Polos"]["selected_size"]);
       
     }
  } 
      else if (multiplier["Polos"]["cart_qty"] == 2) {
    update_mini_cart_upsell_title("Add 1 more Polo Tee to get $68 off");
     if(mini_cart_upsell_items) {
      var upsell_html  = render_upsell_html_polos(multiplier["Polos"]["selected_size"]);
       
     }
  } 
  else {
    update_mini_cart_upsell_title("YOU MAY ALSO LIKE");
  }

  for (var key in multiplier) {
    var bundle_eligible = Math.floor(
      multiplier[key].cart_qty / multiplier[key].m
    );
    if (bundle_eligible > 0) {
      calculated_discount_val += multiplier[key].discount * bundle_eligible;
      discount_array[multiplier[key].index] =
        bundle_eligible * multiplier[key].m + multiplier[key].code;
    }
  }

  var filtered = discount_array.filter(function (el) {
    return el != "";
  });
  var coupon_code = filtered.join("-");

  if (coupon_code) {
    coupon_code = "BDL-" + coupon_code;
    console.log(coupon_code);
    console.log(calculated_discount_val);
    if (mini_cart_savings)
        mini_cart_savings.innerHTML = "Savings unlocked "+window.formatMoney(calculated_discount_val)+"! <br />Apply coupon <strong>"+coupon_code+"</strong> at checkout!"
      
      // mini_cart_savings.innerHTML =
      //   "Total Savings:&nbsp; " + window.formatMoney(calculated_discount_val);
    if (mini_cart_form) mini_cart_form.action = "/cart?discount=" + coupon_code;
  } else {
    if (mini_cart_savings) mini_cart_savings.innerHTML = "&nbsp;";
    if (mini_cart_form) mini_cart_form.action = "/cart";
  }

  if (mini_cart_button_subtotal) {
    mini_cart_button_subtotal.innerHTML =
      ' <span class="square-separator"></span>' +
      window.formatMoney(cart.original_total_price - calculated_discount_val);
  }
}
var shorts_selected_size = "";
function render_upsell_html(selected_size) {
  console.log(selected_size);
 window.shorts_selected_size = selected_size;

   var productUrl = `https://perkclothing.com/products/feel-good-shorts.json`;

  // Load the product data
  loadProductData(productUrl, function(product) {
    console.log("shorts");
    console.log(product);
    var array_imgs = {'Light Khaki' : 'https://cdn.shopify.com/s/files/1/0023/2518/4621/products/Khaki_3.jpg', 
                     'Ink Blue': 'https://cdn.shopify.com/s/files/1/0023/2518/4621/files/ink_1.jpg?v=1689954749&width=240',
                      'Smooth Oak': 'https://cdn.shopify.com/s/files/1/0023/2518/4621/products/Smooth_1.jpg?v=1689954749&width=240',
                      'Riverside Blue': 'https://cdn.shopify.com/s/files/1/0023/2518/4621/files/front_724aa9b0-ef36-4a9f-82ec-5ffed6358bb8.jpg?v=1689954749&width=240'
                     };
    console.log(product);
     var html  = '';

    for (let i = 0; i < product.variants.length; i++) {
  var current_variant = product.variants[i];
      
  if(current_variant['option2'] ==  window.shorts_selected_size  ) {
   
    html += `<product-item class="product-item"><div class="product-item__image-wrapper"><a href="#" onclick="myFunction(this)" data-variant-id="`+current_variant['id']+`" data-instant="" class="product-item__aspect-ratio aspect-ratio" style="padding-bottom:100%;--aspect-ratio:1.0"><img src="`+array_imgs[current_variant['option1']]+`" class="product-item__primary-image" data-media-id="5854680940653" /></a></div><div class="product-item__info text--small"><div class="product-item-meta"><a href="https://perkclothing.com/products/feel-good-shorts" data-instant="">`+current_variant['option1'] +`</a><div style="text-align:center;margin-bottom:5px">`+window.shorts_selected_size+`</div><div style="font-size:10px;text-align:center"><a href="#" onclick="myFunction(this)" data-variant-id="`+current_variant['id']+`" style="padding:5px;background-color:#000;color:#fff;font-size:12px">Add my size</a></div></div></div></product-item>`;
  }
}
    
   
    var mini_cart_upsell_items = document.getElementById("mini-cart-upsell-items");
    mini_cart_upsell_items.innerHTML = html;
  });
  
}

var polos_selected_size = "";
function render_upsell_html_polos(selected_size) {
  console.log(selected_size);
 window.shorts_selected_size = selected_size;

   var productUrl = `https://perkclothing.com/products/perk-feel-good-polo.json`;

  // Load the product data
  loadProductData(productUrl, function(product) {
    var array_imgs = {'Solid Black' : 'https://cdn.shopify.com/s/files/1/0023/2518/4621/files/a_30fc30ee-902d-40a6-891f-509f74bb211f.jpg?v=1695649783&width=240', 
                     'Deep Sea': 'https://cdn.shopify.com/s/files/1/0023/2518/4621/files/01.jpg?v=1695649783&width=240',
                      'Ink Blue': 'https://cdn.shopify.com/s/files/1/0023/2518/4621/files/2_cd89fbc9-0347-4bb6-b19b-722ca4f43617.jpg?v=1695649783&width=240',
                      'Faded Forest': 'https://cdn.shopify.com/s/files/1/0023/2518/4621/files/b_222f5a9c-c993-4f2e-bafd-31ef16f961d5.jpg?v=1695214871&width=240',
                      'Burnt Red': 'https://cdn.shopify.com/s/files/1/0023/2518/4621/files/001.jpg?v=1695649783&width=240',
                      'Stone': 'https://cdn.shopify.com/s/files/1/0023/2518/4621/files/stone_eab21713-3b23-4c91-8c57-90dd72466e8c.jpg?v=1695649783&width=240',
                      'Graphite': 'https://e1lf951ajaoxr5g1-2325184621.shopifypreview.com/cdn/shop/files/1_1465a947-2ae0-4c0d-ae7c-079426370af4_240x.jpg'
                     };
    console.log(product);
     var html  = '';

    for (let i = 0; i < product.variants.length; i++) {
  var current_variant = product.variants[i];
      
  if(current_variant['option2'] ==  window.shorts_selected_size) {
   
    html += `<product-item class="product-item"><div class="product-item__image-wrapper"><a href="#" onclick="myFunction(this)" data-variant-id="`+current_variant['id']+`" data-instant="" class="product-item__aspect-ratio aspect-ratio" style="padding-bottom:100%;--aspect-ratio:1.0"><img src="`+array_imgs[current_variant['option1']]+`" class="product-item__primary-image" data-media-id="5854680940653" /></a></div><div class="product-item__info text--small"><div class="product-item-meta"><a href="https://perkclothing.com/products/feel-good-shorts" data-instant="">`+current_variant['option1'] +`</a><div style="text-align:center;margin-bottom:5px">`+window.shorts_selected_size+`</div><div style="font-size:10px;text-align:center"><a href="#" onclick="myFunction(this)" data-variant-id="`+current_variant['id']+`" style="padding:5px;background-color:#000;color:#fff;font-size:12px">Add my size</a></div></div></div></product-item>`;
  }
}
    
   
    var mini_cart_upsell_items = document.getElementById("mini-cart-upsell-items");
    mini_cart_upsell_items.innerHTML = html;
  });
  
}

function apply_coupon(coupon_code, cart_data = "") {
  console.log(coupon_code);
  if (cart_data) apply_coupon_final(coupon_code, cart_data);
  else {
    fetch("/cart.js")
      .then(function (response) {
        if (response.status !== 200) {
          console.log(
            "Looks like there was a problem. Status Code: " + response.status
          );
          return;
        }

        // Examine the text in the response
        response.json().then(function (data) {
          apply_coupon_final(coupon_code, data);
        });
      })
      .catch(function (err) {
        console.log("Fetch Error :-S", err);
      });
  }
}

function apply_coupon_final(coupon_code, cart) {
  
  if(coupon_code == "CHINO20OFF") {
    apply_coupon_final_fg(coupon_code, cart);
    return;
  }
  
  if(coupon_code.includes("20LABOR")) {
    apply_coupon_final_ld(coupon_code, cart);
    return;
  }
  
   var chinos_price_graph = document.getElementById("chinos-price-graph");
  console.log(coupon_code);
  var mini_cart_savings = document.getElementById("mini-cart-savings");
  var mini_cart_form = document.getElementById("mini-cart-form");
  var mini_cart_button_subtotal = document.getElementById(
    "mini-cart-button-subtotal"
  );

  var discount_for_coupon = 0;

  if (chinos_price_graph) {
    chinos_price_graph.style.display = "none";
  }

  if (coupon_code == "CHINO30OFF") {
    discount_for_coupon = 10710;
  } else if (coupon_code == "CHINO100OFF") {
    discount_for_coupon = 10000;
  }

  var calculated_discount_val = 0;
  var discount_array = ["", ""];
  var multiplier = {
    "T-Shirts": {
      m: 3,
      index: 0,
      code: "T",
      cart_qty: 0,
      discount: 1500,
    },
    Chinos: {
      m: 3,
      index: 1,
      code: "C",
      cart_qty: 0,
      discount: 8700,
    },
    Shorts: {
      m: 2,
      index: 2,
      code: "S",
      cart_qty: 0,
      discount: 4900,
      selected_size: ''
    }
  };
  var cart_items = cart.items;

  for (var i = 0; i < cart_items.length; i++) {
    var cart_item = cart_items[i];

    if (multiplier[cart_item.product_type])
      multiplier[cart_item.product_type].cart_qty += cart_item.quantity;
  }

 if (multiplier["Chinos"]["cart_qty"] == 1) {
    update_mini_cart_upsell_title(
      "Add 2 more Chinos to get " +
        window.formatMoney(discount_for_coupon) +
        " off"
    );
  } else if (multiplier["Chinos"]["cart_qty"] == 2) {
    update_mini_cart_upsell_title(
      "Add 1 more Chinos to get " +
        window.formatMoney(discount_for_coupon) +
        " off"
    );
  } else {
    update_mini_cart_upsell_title("YOU MAY ALSO LIKE");
  }

  for (var key in multiplier) {
    var bundle_eligible = Math.floor(
      multiplier[key].cart_qty / multiplier[key].m
    );
    if (bundle_eligible > 0) {
      calculated_discount_val += multiplier[key].discount * bundle_eligible;
      discount_array[multiplier[key].index] =
        bundle_eligible * multiplier[key].m + multiplier[key].code;
    }
  }

  var filtered = discount_array.filter(function (el) {
    return el != "";
  });
  var coupon_code_raw = filtered.join("-");

  if(!coupon_code_raw) {
    coupon_code = ""
  }
  else if(coupon_code_raw != "3C") {
    coupon_code = "BDL-" + coupon_code_raw;
  }
  else if(coupon_code_raw == "3C") {
    calculated_discount_val = discount_for_coupon;
  }

  if (coupon_code) {
    if (mini_cart_savings) {
      
     
        mini_cart_savings.innerHTML = "Savings unlocked $"+window.formatMoney(calculated_discount_val)+"! Apply coupon "+coupon_code+" at checkout!"
      
      // else {
      // mini_cart_savings.innerHTML =
      //   "Total Savings:&nbsp; " + window.formatMoney(calculated_discount_val);
      //   }
      }
    if (mini_cart_form) mini_cart_form.action = "/cart?discount=" + coupon_code;
  } else {
    if (mini_cart_savings) mini_cart_savings.innerHTML = "&nbsp;";
    if (mini_cart_form) mini_cart_form.action = "/cart";
  }

  if (mini_cart_button_subtotal) {
    mini_cart_button_subtotal.innerHTML =
      ' <span class="square-separator"></span>' +
      window.formatMoney(cart.total_price - calculated_discount_val);
  }
}
function apply_coupon_final_fg(coupon_code, cart) {
   var chinos_price_graph = document.getElementById("chinos-price-graph");
  var chinos_price_graph20off = document.getElementById("shopify-section-template--14669953433709__3bcff936-a0d3-486e-8404-fe4445ae7d85");
  console.log(coupon_code);
   var chinos_price_graph20off = document.querySelector('[id$="3bcff936-a0d3-486e-8404-fe4445ae7d85"]');
  
  var mini_cart_savings = document.getElementById("mini-cart-savings");
  var mini_cart_form = document.getElementById("mini-cart-form");
  var mini_cart_button_subtotal = document.getElementById(
    "mini-cart-button-subtotal"
  );

  var pdp_intro_text = document.getElementById("chinos-intro-offer-text");

  if(pdp_intro_text) {
    pdp_intro_text.innerHTML = "Buy 2 Chinos, Save 20% and Get a Free Tee!";
  }
  
  var compare_at_savings = 0;

  var count_free_fgt = 0;

  var discount_for_coupon = 0;

  if (chinos_price_graph) {
    chinos_price_graph.style.display = "none";
   //  chinos_price_graph.innerHTML = '<img src="https://cdn.shopify.com/s/files/1/0023/2518/4621/files/free_tee_offer.jpg" />';
  }
  if(chinos_price_graph20off) {
    chinos_price_graph20off.style.display = "block";
  }

  if (coupon_code == "CHINO30OFF") {
    discount_for_coupon = 10710;
  } else if (coupon_code == "CHINO100OFF") {
    discount_for_coupon = 10000;
  }
  else if (coupon_code == "CHINO20OFF") {
    discount_for_coupon = 4760;
  }

  var calculated_discount_val = 0;
  var discount_array = ["", ""];
  var multiplier = {
    "T-Shirts": {
      m: 3,
      index: 0,
      code: "T",
      cart_qty: 0,
      discount: 1500,
    },
    Chinos: {
      m: 3,
      index: 1,
      code: "C",
      cart_qty: 0,
      discount: 8700,
    },
    Shorts: {
      m: 2,
      index: 2,
      code: "S",
      cart_qty: 0,
      discount: 4900,
      selected_size: ''
    }
  };
  var cart_items = cart.items;

  for (var i = 0; i < cart_items.length; i++) {
    var cart_item = cart_items[i];

    if (multiplier[cart_item.product_type])
      multiplier[cart_item.product_type].cart_qty += cart_item.quantity;

    if (cart_item.title.includes("Free Feel Good Tee")) {
      compare_at_savings += 3800;
      count_free_fgt += 1;
    }    
  }

  console.log("helo"+compare_at_savings);

 if (multiplier["Chinos"]["cart_qty"] == 1) {
    update_mini_cart_upsell_title(
      "Add 1 more Chinos to get a FREE TEE & " +
        window.formatMoney(discount_for_coupon) +
        " off"
    );
  }  else {
    update_mini_cart_upsell_title("YOU MAY ALSO LIKE");
  }

  for (var key in multiplier) {
    var bundle_eligible = Math.floor(
      multiplier[key].cart_qty / multiplier[key].m
    );
    if (bundle_eligible > 0) {
      calculated_discount_val += multiplier[key].discount * bundle_eligible;
      discount_array[multiplier[key].index] =
        bundle_eligible * multiplier[key].m + multiplier[key].code;
    }
  }

  var filtered = discount_array.filter(function (el) {
    return el != "";
  });
  var coupon_code_raw = filtered.join("-");


  if(multiplier["Chinos"]["cart_qty"] !== 2 && coupon_code_raw !== "3C") {
    if(!coupon_code_raw)
      coupon_code = ""
    else
      coupon_code = "BDL-" + coupon_code_raw;
  }
  else {
var collectionHandle = 'free-gift';
if(count_free_fgt == 0) {
renderProductSection("free-feel-good-tee");

}
    
   // var free_gift_html = `<div class="free-gift-grid"><div class="free-gift-column">Column 1</div><div class="free-gift-column">Column 2</div><div class="free-gift-column">Column 3</div></div>`;
    //var free_gift_container = document.getElementById("free-gift-container");
    // free_gift_container.innerHTML = free_gift_html;
    calculated_discount_val = discount_for_coupon;
  }  

  var new_calculated_discount_val = calculated_discount_val+ compare_at_savings;

  if (coupon_code) {
    if (mini_cart_savings)
      mini_cart_savings.innerHTML =
        "Total Savings:&nbsp; " + window.formatMoney(new_calculated_discount_val);
    if (mini_cart_form) mini_cart_form.action = "/cart?discount=" + coupon_code;
  } else {
    if (mini_cart_savings) mini_cart_savings.innerHTML = "&nbsp;";
    if (mini_cart_form) mini_cart_form.action = "/cart";
  }

  if (mini_cart_button_subtotal) {
    mini_cart_button_subtotal.innerHTML =
      ' <span class="square-separator"></span>' +
      window.formatMoney(cart.total_price - calculated_discount_val);
  }
}
function apply_coupon_final_ld(coupon_code, cart) {
  var chinos_price_graph = document.getElementById("chinos-price-graph");
  var chinos_price_graph20off = document.querySelector(
    '[id$="15b1c08c-6f08-4717-ade4-92c833f018b2"]',
  );
  var free_shipping_bar = document.querySelector("free-shipping-bar");
  var mini_cart_savings = document.getElementById("mini-cart-savings");
  var mini_cart_form = document.getElementById("mini-cart-form");
  var mini_cart_button_subtotal = document.getElementById(
    "mini-cart-button-subtotal",
  );
  var free_meter_box = document.getElementById("freeTeeMeterBox");

  var sale_off_badge_pdp = document.getElementById("sale-off-badge-pdp");

  var sale_off_badge_list = document.querySelectorAll(".sale-off-badge-list");
  var bundle_label = document.querySelectorAll(".bundle-label");

  if (sale_off_badge_list) {
    // Loop through each element and set its display property to "none"
    sale_off_badge_list.forEach((element) => {
      element.style.display = "block";
    });
  }

  if (bundle_label) {
    // Loop through each element and set its display property to "none"
    bundle_label.forEach((element) => {
      element.style.display = "none";
    });
  }

  var pdp_intro_text = document.getElementById("chinos-intro-offer-text");

  if (pdp_intro_text) {
    pdp_intro_text.innerHTML =
      "Celebrate Labor Day with 20% OFF everything + a Free Tee on orders over $250! Ends on September 5th at 23:59 ET.";
  }

  var compare_at_savings = 0;

  var count_free_fgt = 0;

  var discount_for_coupon = 0;

  if (chinos_price_graph) {
    chinos_price_graph.style.display = "none";
    //  chinos_price_graph.innerHTML = '<img src="https://cdn.shopify.com/s/files/1/0023/2518/4621/files/free_tee_offer.jpg" />';
  }
  if (sale_off_badge_pdp) {
    sale_off_badge_pdp.style.display = "block";
  }
  if (chinos_price_graph20off) {
    chinos_price_graph20off.style.display = "block";
  }
  free_shipping_bar.style.display = "none";
  if (free_meter_box) {
    free_meter_box.style.display = "block";

    const cartTotal = cart.total_price / 100; // Example cart total
    const thresholdForFreeTee = 250;

    // Calculate the remaining amount needed for a free tee
    const remainingAmount = thresholdForFreeTee - cartTotal;

    // Calculate the progress percentage
    const progressPercentage = Math.min(
      (cartTotal / thresholdForFreeTee) * 100,
      100,
    );

    // Update the meter bar width and remaining amount
    const meterBar = document.getElementById("freeTeeMeterBar");
    const remainingAmountSpan = document.getElementById("remainingAmount");
    meterBar.style.width = `${progressPercentage}%`;
    remainingAmountSpan.textContent = `$${remainingAmount.toFixed(2)}`;

    // Hide the bar if user is eligible for a free tee
    if (remainingAmount <= 0) {
      const meterBarContainer = document.getElementById(
        "freeTeeMeterBarContainer",
      );
      meterBarContainer.style.display = "none";
      const freeTeeText = document.getElementById("freeTeeText");
      freeTeeText.textContent =
        "Congratulations! You're eligible for a free tee!";
    }
  }

  discount_for_coupon = 0;

  var calculated_discount_val = 0;
  var discount_array = ["", ""];
  var multiplier = {
    "T-Shirts": {
      m: 3,
      index: 0,
      code: "T",
      cart_qty: 0,
      discount: 1500,
    },
    Chinos: {
      m: 3,
      index: 1,
      code: "C",
      cart_qty: 0,
      discount: 8700,
    },
    Shorts: {
      m: 2,
      index: 2,
      code: "S",
      cart_qty: 0,
      discount: 4900,
      selected_size: ''
    }
  };
  var cart_items = cart.items;

  for (var i = 0; i < cart_items.length; i++) {
    var cart_item = cart_items[i];

    if (multiplier[cart_item.product_type])
      multiplier[cart_item.product_type].cart_qty += cart_item.quantity;

    if (cart_item.title.includes("Free Feel Good Tee")) {
      compare_at_savings += 3800;
      count_free_fgt += 1;
    }
  }

  console.log("helo" + compare_at_savings);

  // if (multiplier["Chinos"]["cart_qty"] == 1) {
  //    update_mini_cart_upsell_title(
  //      "Add 1 more Chinos to get a FREE TEE & " +
  //        window.formatMoney(discount_for_coupon) +
  //        " off"
  //    );
  //  }  else {
  //    update_mini_cart_upsell_title("YOU MAY ALSO LIKE");
  //  }

  update_mini_cart_upsell_title(
    "ADD 1 MORE PRODUCT! KEEP ENJOYING OUR 20% SALE!",
  );

  for (var key in multiplier) {
    var bundle_eligible = Math.floor(
      multiplier[key].cart_qty / multiplier[key].m,
    );
    if (bundle_eligible > 0) {
      calculated_discount_val += multiplier[key].discount * bundle_eligible;
      discount_array[multiplier[key].index] =
        bundle_eligible * multiplier[key].m + multiplier[key].code;
    }
  }

  var filtered = discount_array.filter(function (el) {
    return el != "";
  });
  var coupon_code_raw = filtered.join("-");

  // if(multiplier["Chinos"]["cart_qty"] !== 2 && coupon_code_raw !== "3C") {
  //   if(!coupon_code_raw)
  //     coupon_code = ""
  //   else
  //     coupon_code = "BDL-" + coupon_code_raw;
  // }
  // else {

  //  // var free_gift_html = `<div class="free-gift-grid"><div class="free-gift-column">Column 1</div><div class="free-gift-column">Column 2</div><div class="free-gift-column">Column 3</div></div>`;
  //   //var free_gift_container = document.getElementById("free-gift-container");
  //   // free_gift_container.innerHTML = free_gift_html;

  // }
  var collectionHandle = "free-gift";
  calculated_discount_val = discount_for_coupon;

  if (count_free_fgt == 0 && cart.total_price > 25000) {
    renderProductSection("free-feel-good-tee");
  }

  var new_calculated_discount_val =
    calculated_discount_val + compare_at_savings;

  if (coupon_code) {
    if (mini_cart_savings)
      mini_cart_savings.innerHTML = "Labor Day 20% savings unlocked!";
    if (mini_cart_form) mini_cart_form.action = "/cart?discount=" + coupon_code;
  } else {
    if (mini_cart_savings) mini_cart_savings.innerHTML = "&nbsp;";
    if (mini_cart_form) mini_cart_form.action = "/cart";
  }

  if (mini_cart_button_subtotal) {
    mini_cart_button_subtotal.innerHTML =
      ' <span class="square-separator"></span>' +
      window.formatMoney(cart.total_price - calculated_discount_val);
  }
}
function update_mini_cart_upsell_title(title) {
  setTimeout(function () {
    console.log(title);
    var mini_cart_heading_mobile = document.getElementById(
      "mini-cart__recommendations-heading-mobile"
    );
    var mini_cart_heading_desk = document.getElementById(
      "mini-cart__recommendations-heading-desk"
    );
    if (mini_cart_heading_mobile) mini_cart_heading_mobile.innerHTML = title;
    if (mini_cart_heading_desk) mini_cart_heading_desk.innerHTML = title;
  }, 1000);
}
// Create a global variable to store the product data
var productData;

// Create a function to load the product data from the JSON API
function loadProductData(productUrl, callback) {
  // Make an AJAX request to fetch the product data
  var xhr = new XMLHttpRequest();
  xhr.open('GET', productUrl);
  xhr.onload = function() {
    if (xhr.status === 200) {
      // Parse the response JSON
      var response = JSON.parse(xhr.responseText);
      // Pass the product data to the callback function
      callback(response.product);
    }
  };
  xhr.send();
}
current_free_product =  "";
// Create a function to render the product section
function renderProductSection(productId) {
  window.current_free_product = productId;

  var productUrl = `https://perkclothing.com/products/${productId}.json`;

  // Load the product data
  loadProductData(productUrl, function (product) {
    // Store the product data in the global variable
    productData = product;
    console.log("free");
    console.log(product);

    // Get the container element
    var container = document.getElementById("free-gift-container");
    var product_label =
      current_free_product == "perk-feel-good-polo" ? "POLO" : "TEE";
    var product_price =
      current_free_product == "perk-feel-good-polo" ? "89" : "38";

    if (current_free_product == "perk-feel-good-shorts") {
      var product_label = "Shorts";
      var product_price = "99";
    }

    // Create the HTML markup for the product section
    var productSectionHtml =
      `
      <div style="margin-top:20px;margin-bottom:10px;border: 1px solid; padding: 10px;border: 1px solid #000000;
border-radius: 8px;background: #F2F2F2;"><div><div style="width:78%;float:left"> <strong class="h7">YOU’VE UNLOCKED A FREE ` +
      product_label +
      `!</strong><br /><span style="color:#e24337;" class="text--small">To claim: Select Size</span></div> <div style="width:20%;float:right"><div style="line-height: 1; margin-bottom: 10px;"><span style="text-decoration: line-through;">$` +
      product_price +
      `</span> <strong>FREE</strong></div></div></div><div class="product-section">
        <div style="float:left;width:150px;">
          <img id="fg-img" src="${product.image.src}" alt="${product.title}">
          </div>
           <div style="float:left;padding-top:20px;padding-left:20px;">
             <div class="color-select-wrapper" style="margin-bottom:4px;">
              <label for="colorSelect" class="text--small">Color: We’ll surprise you!</label>
              <input type="hidden" name="colorSelect" id="colorSelect" value="Select Color" />
              <div class="color-swatches">
                ${generateColorSwatches(product.options)}
              </div>
            </div>
       <div style="margin-bottom:10px;">
           <select id="sizeSelect" onchange="updateAddToCartButton(this)" disabled style="display:block">
            <option disabled selected value="Select Size">Select Size</option>
          </select>
          </div>
          
        <div style="margin-top:10px;">
        <a href="#" onclick="myFunction(this)" id="fg-atc" data-variant-id="11" style="background-color: #000000; color: #ffffff; font-size:12px;width:80px;text-align:center;display:none;">Add Free Tee</a>
        </div>
        </div><div style="clear: both; "></div>
      </div></div>
    `;

    // Append the product section HTML to the container
    container.innerHTML = productSectionHtml;
    if (current_free_product == "perk-feel-good-polo") selectColor("Deep Sea");
    else if (current_free_product == "perk-feel-good-shorts")
      selectColor("Smooth Oak");
    else selectColor("Jet Black");
  });
}
// Function to generate color swatches based on product options
function generateColorSwatches(options) {
  if (!options || options.length === 0) {
    return '<div class="no-color-options">No color options available</div>';
  }

  var colorOptions = options.find(
    (option) => option.name.toLowerCase() === "color"
  );

  if (!colorOptions) {
    return '<div class="no-color-options">No color options available</div>';
  }

  // [ "Deep Sea", "Burnt Red", "Stone", "Graphite", "Solid Black", "Ink Blue", "Faded Forest", ] polo
  // [ "Smooth Oak", "Ink Blue", "Riverside Blue", "Light Khaki", ] shorts
  
  return colorOptions.values
    .filter((value) =>
      [
        "JET Black",
        "Ink Blue"
      ].includes(value)
    )
    .map((value) => {
      var colorClass =
        "fg-color-swatch-" + value.toLowerCase().replace(/\s+/g, "-");
      return `<div style="display:none;" class="fg-color-swatch ${colorClass}" onclick="selectColor('${value}')"></div>`;
    })
    .join("");
}

function selectColor(color) {
  var colorSelect = document.getElementById("colorSelect");
  colorSelect.value = color;
  if (current_free_product == "perk-feel-good-polo") {
    var color_images = {
      "Solid Black":
        "https://cdn.shopify.com/s/files/1/0023/2518/4621/files/non-color-polo.jpg?v=1718636462&width=240",
      "Deep Sea":
        "https://cdn.shopify.com/s/files/1/0023/2518/4621/files/non-color-polo.jpg?v=1718636462&width=240",
      "Ink Blue":
        "https://cdn.shopify.com/s/files/1/0023/2518/4621/files/2_cd89fbc9-0347-4bb6-b19b-722ca4f43617.jpg?v=1695649783&width=240",
      "Faded Forest":
        "https://cdn.shopify.com/s/files/1/0023/2518/4621/files/b_222f5a9c-c993-4f2e-bafd-31ef16f961d5.jpg?v=1695214871&width=240",
      "Burnt Red":
        "https://cdn.shopify.com/s/files/1/0023/2518/4621/files/001.jpg?v=1695649783&width=240",
      Stone:
        "https://cdn.shopify.com/s/files/1/0023/2518/4621/files/stone_eab21713-3b23-4c91-8c57-90dd72466e8c.jpg?v=1695649783&width=240",
      Graphite:
        "https://e1lf951ajaoxr5g1-2325184621.shopifypreview.com/cdn/shop/files/1_1465a947-2ae0-4c0d-ae7c-079426370af4_240x.jpg",
    };
    console.log(color_images);
  } else if (current_free_product == "perk-feel-good-shorts") {
    var color_images = {
      "Smooth Oak":
        "https://perkclothing.com/cdn/shop/files/Short_smoothoak_4d920788-be3c-4773-ae75-ca2c792e4547.jpg?v=1695649783&width=240",
      "Ink Blue":
        "https://perkclothing.com/cdn/shop/files/Short_inkblue_3ec86654-2b8a-4a9f-a2df-76d497d3d9ed.jpg?v=1715185999&width=240",
      "Riverside Blue":
        "https://perkclothing.com/cdn/shop/files/Perk_Product_Square_1_41a64e3f-0c35-40b5-890d-a3993377cf55.jpg?v=1715186029&width=240",
      "Light Khaki":
        "https://perkclothing.com/cdn/shop/files/Short_Khaki_f8af8b0e-50a8-45c1-90d9-5dff0ee8d93d.jpg?v=1715186010&width=240",
    };
    console.log(color_images);
  } else
    var color_images = {
      "Jet Black":
        "https://cdn.shopify.com/s/files/1/0023/2518/4621/files/grey-fgt.jpg",
      "Pacific Blue":
        "https://perkclothing.com/cdn/shop/files/pacific-blue.jpg",
      Yellowstone: "https://perkclothing.com/cdn/shop/files/yellow-stone.jpg",
    };

  var imageElement = document.getElementById("fg-img");
  imageElement.src = color_images[color];
  updateSizeOptions();
}
// Function to update the size options based on the selected color
// Function to update the size options based on the selected color
function updateSizeOptions() {
 var size_arr = ["S", "M", "L", "XL", "2X", "3X"];
 // var size_arr = ["30", "32", "34", "36", "38"];
  var colorSelect = document.getElementById("colorSelect");
  var sizeSelect = document.getElementById("sizeSelect");
  var selectedColor = colorSelect.value;

  var size_select = "<option disabled selected>Select Size</option>";

  // Find the selected color option
  var selectedColorOption = productData.options.find(
    (option) => option.name.toLowerCase() === "color"
  );
  if (!selectedColorOption) {
    return;
  }

  // Filter variants based on selected size and availability
  size_arr.forEach(function (size) {
    for (let i = 0; i < productData.variants.length; i++) {
      var current_variant = productData.variants[i];

      // Check if variant matches size and is available
      if (
        current_variant["option2"] == size &&
        window.freePoloProductInventoryData[current_variant["id"]] > 0
      ) {
        size_select +=
          '<option data-variant-id="' +
          current_variant["id"] +
          '" value="' +
          current_variant["id"] +
          '">' +
          current_variant["option2"] +
          "</option>";
        break;
      }
    }
  });

  sizeSelect.innerHTML = size_select;
  sizeSelect.disabled = false;

  // Update the state of the Add to Cart button if needed
  // updateAddToCartButton();
}


// Function to update the Add to Cart button state based on the selection
function updateAddToCartButton(event) {
  var colorSelect = document.getElementById('colorSelect');
  var sizeSelect = document.getElementById('sizeSelect');
  var addToCartButton = document.getElementById('fg-atc');
    if(sizeSelect !== "Select Size") {
    myFunction(event);
    return;
  }

  if (colorSelect.value !== 'Select Color' && sizeSelect.value !== 'Select Size') {
    addToCartButton.disabled = false;
    // Get the hyperlink element
var linkElement = document.getElementById('fg-atc');

// Change the value of the data-variant-id attribute
linkElement.dataset.variantId = sizeSelect.value;

    
  } else {
    addToCartButton.disabled = true;
  }
}

// Function to handle the Add to Cart button click
function addToCart() {
  // Logic to add the selected product to the cart
  // You can customize this according to your needs
  console.log('Adding product to cart...');
}
function submitCheckout(current_form){
  var current_action = current_form.getAttribute("action");
  var url_parts = current_action.split("discount=");
  
  if(url_parts.length > 1) {
    window.location.href = "/discount/"+url_parts[1]+"?redirect=/checkout";
  }
  else {
     window.location.href = "/checkout";
  }
  
}

function apply_coupon_final_ps(coupon_code, cart) {

const cartTotal = cart.total_price/100 // Example cart total
  console.log(cart);
var chinos_price_graph = document.getElementById("chinos-price-graph");
var chinos_price_graph20off = document.querySelector('[id$="15b1c08c-6f08-4717-ade4-92c833f018b2"]');
var free_shipping_bar = document.querySelector('free-shipping-bar');
var mini_cart_savings = document.getElementById("mini-cart-savings");
var mini_cart_form = document.getElementById("mini-cart-form");
var mini_cart_button_subtotal = document.getElementById(
"mini-cart-button-subtotal"
);
var free_meter_box = document.getElementById("freeTeeMeterBox");
var sale_off_badge_pdp = document.getElementById("sale-off-badge-pdp");
var sale_off_badge_list = document.querySelectorAll('.sale-off-badge-list')
var pdp_intro_text = document.getElementById("chinos-intro-offer-text");

 var mini_cart_discount = document.getElementsByClassName("mini-cart__discount");
  
if(sale_off_badge_list) {
// Loop through each element and set its display property to "none"
sale_off_badge_list.forEach(element => {
  element.style.display = 'block';
});
}

  if(mini_cart_discount.length > 0) {
    mini_cart_discount[0].style.display = 'none';
  }


  // Calculate the progress percentage
var progressPercentage = 0;
  var step_1 = document.getElementById("step-1");
  var step_2 = document.getElementById("step-2");
  var step_3 = document.getElementById("step-3");
      // Update the meter bar width and remaining amount
    const meterBar = document.getElementById("freeTeeMeterBar");
    const remainingAmountSpan = document.getElementById("remainingAmount");
  if(cartTotal < 250 && cartTotal > 0) {
    var remainingAmount = 250 - cartTotal;
    remainingAmountSpan.innerHTML = "<strong>You’re $"+remainingAmount.toFixed(2)+" away to get additional $30 discount</strong>";
    progressPercentage = 5;
  }
  
  if(cartTotal == 250) {
    progressPercentage = 10;
  }

   if(cartTotal > 250 && cartTotal < 350) {
     var remainingAmount = 350 - cartTotal;
    remainingAmountSpan.innerHTML = "$30 OFF Unlocked! <br /><strong>You’re $"+remainingAmount.toFixed(2)+" away to get additional $50 discount</strong>";
    step_1.classList.add("active");
     step_2.classList.remove("active");
     step_3.classList.remove("active");
    progressPercentage = 30;
  }

  
   if(cartTotal == 350) {
    progressPercentage = 50;
  }

    
   if(cartTotal > 350 && cartTotal < 500) {
     var remainingAmount = 500 - cartTotal;
    remainingAmountSpan.innerHTML = "$50 OFF Unlocked! <br /><strong>You’re $"+remainingAmount.toFixed(2)+" away to get additional $100 discount</strong>";
     step_1.classList.add("active");
      step_2.classList.add("active");
      step_3.classList.remove("active");
    progressPercentage = 70;
  }
    if(cartTotal == 500) {
    progressPercentage = 90;
  }

  if(cartTotal > 500) {
    remainingAmountSpan.innerHTML = "$100 OFF Unlocked!";
    step_1.classList.add("active");
      step_2.classList.add("active");
     step_3.classList.add("active");
    progressPercentage = 100;
  }

   


    meterBar.style.width = `${progressPercentage}%`;


  if(pdp_intro_text) {
    pdp_intro_text.innerHTML = "Celebrate Perk 4th Anniversary with 20% OFF everything";
  }
  
  var compare_at_savings = 0;

  var count_free_fgt = 0;

  var discount_for_coupon = 0;

  if (chinos_price_graph) {
    chinos_price_graph.style.display = "none";
   //  chinos_price_graph.innerHTML = '<img src="https://cdn.shopify.com/s/files/1/0023/2518/4621/files/free_tee_offer.jpg" />';
  }
  if(sale_off_badge_pdp) {
    sale_off_badge_pdp.style.display = "block";
  }
  if(chinos_price_graph20off) {
   //  chinos_price_graph20off.style.display = "block";
  }
  // if(free_shipping_bar)
  //   free_shipping_bar.style.display = "none";
  // if(free_meter_box ) {
  //   free_meter_box.style.display = "block";

     
   

  discount_for_coupon = 0;

  var calculated_discount_val = 0;
  var discount_array = ["", ""];
  var multiplier = {
    "T-Shirts": {
      m: 3,
      index: 0,
      code: "T",
      cart_qty: 0,
      discount: 1500,
    },
    Chinos: {
      m: 3,
      index: 1,
      code: "C",
      cart_qty: 0,
      discount: 8700,
    },
     Shorts: {
      m: 2,
      index: 2,
      code: "S",
      cart_qty: 0,
      discount: 4900,
      selected_size: ''
    },
  };
  var cart_items = cart.items;
  var coupon_discount_exist = false;
  var labor20discount = 0;

  for (var i = 0; i < cart_items.length; i++) {
    var cart_item = cart_items[i];

    if(cart_item.discounts[0] !== undefined) {
      if(cart_item.discounts[0].title.includes(coupon_code)) {
        coupon_discount_exist = true;
      }
    }

    if (multiplier[cart_item.product_type]) {
      multiplier[cart_item.product_type].cart_qty += cart_item.quantity;
      
      if(cart_item.discounts[0] == undefined)
        labor20discount += cart_item.original_line_price*0.20;
    }

      
  }



 // if (multiplier["Chinos"]["cart_qty"] == 1) {
 //    update_mini_cart_upsell_title(
 //      "Add 1 more Chinos to get a FREE TEE & " +
 //        window.formatMoney(discount_for_coupon) +
 //        " off"
 //    );
 //  }  else {
 //    update_mini_cart_upsell_title("YOU MAY ALSO LIKE");
 //  }

  update_mini_cart_upsell_title("ADD 1 MORE PRODUCT! KEEP ENJOYING OUR 20% SALE!");

  for (var key in multiplier) {
    var bundle_eligible = Math.floor(
      multiplier[key].cart_qty / multiplier[key].m
    );
    if (bundle_eligible > 0) {
      calculated_discount_val += multiplier[key].discount * bundle_eligible;
      discount_array[multiplier[key].index] =
        bundle_eligible * multiplier[key].m + multiplier[key].code;
    }
  }

  var filtered = discount_array.filter(function (el) {
    return el != "";
  });
  var coupon_code_raw = filtered.join("-");


  // if(multiplier["Chinos"]["cart_qty"] !== 2 && coupon_code_raw !== "3C") {
  //   if(!coupon_code_raw)
  //     coupon_code = ""
  //   else
  //     coupon_code = "BDL-" + coupon_code_raw;
  // }
  // else {

    
  //  // var free_gift_html = `<div class="free-gift-grid"><div class="free-gift-column">Column 1</div><div class="free-gift-column">Column 2</div><div class="free-gift-column">Column 3</div></div>`;
  //   //var free_gift_container = document.getElementById("free-gift-container");
  //   // free_gift_container.innerHTML = free_gift_html;
    
  // }  
  var collectionHandle = 'free-gift';
calculated_discount_val = labor20discount > 0 ? labor20discount : discount_for_coupon;

 

  var new_calculated_discount_val = calculated_discount_val+ compare_at_savings;

  if (coupon_code) {
    if (mini_cart_savings) {
  
    var savings_html = "Anniversary Sale 20% savings unlocked! "+"<br />Apply coupon <strong>"+coupon_code+"</strong> at checkout!"
    if(calculated_discount_val > 0) {
    savings_html +=
        "<br />Total Savings:&nbsp; " + window.formatMoney(calculated_discount_val);
    }
    
    mini_cart_savings.innerHTML = savings_html;
    }
    if (mini_cart_form) mini_cart_form.action = "/cart?discount=" + coupon_code;
  } else {
    if (mini_cart_savings) mini_cart_savings.innerHTML = "&nbsp;";
    if (mini_cart_form) mini_cart_form.action = "/cart";
  }

  if (mini_cart_button_subtotal) {
    mini_cart_button_subtotal.innerHTML =
      ' <span class="square-separator"></span>' +
      window.formatMoney(cart.total_price - calculated_discount_val);
  }
}
/*
    function updateTimer() {
        const saleEndTime = new Date("2023-11-08T04:00:00-07:00");

        const timerInterval = setInterval(() => {
            const currentTime = new Date().getTime();
            const timeDifference = saleEndTime - currentTime;

            if (timeDifference <= 0) {
                clearInterval(timerInterval);
              if(document.getElementById("timer"))
                document.getElementById("timer").innerHTML = "Sale has ended!";
            } else {
                const hours = Math.floor((timeDifference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
                const minutes = Math.floor((timeDifference % (1000 * 60 * 60)) / (1000 * 60));
                const seconds = Math.floor((timeDifference % (1000 * 60)) / 1000);
                if(document.getElementById("timer"))
                document.getElementById("timer").innerHTML = 'Sale Ends in: '+ `${hours}h ${minutes}m ${seconds}s`;
            }
        }, 1000);
    }

    window.onload = function () {
        updateTimer();
    };
*/

  var originalDocTitle = document.title;

  document.addEventListener("visibilitychange", function() {
    if (document.visibilityState === 'hidden') {
      document.title = "Baby come back! \uD83C\uDFB5";
    } else {
      document.title = originalDocTitle;
    }
  });

 function toggleSeoDescText() {
        var moreText = document.getElementById("seo-desc-more-text");
        var toggleLink = document.getElementById("toggleSeoDescLink");

        if (moreText.style.display === "none") {
            moreText.style.display = "inline";
            toggleLink.textContent = " - See Less";
        } else {
            moreText.style.display = "none";
            toggleLink.textContent = " - Read More";
        }
    }

